/**
 * NotificationPreferenceTypes.js
 *
 * @description :: Constants for notification preference types and related enums
 */

// Preference types matching the backend model
export const PREFERENCE_TYPES = {
  GLOBAL: "Global",
  FOUNDATION: "Foundation",
  FUND: "Fund"
};

// Target ID constants
export const GLOBAL_TARGET_ID = 0; // Global preferences always use targetId = 0

// Search configuration
export const SEARCH_DEBOUNCE_DELAY = 300; // Milliseconds to wait before searching

// Exclude logic states (foundation enabled + fund disabled = exclude)
export const EXCLUDE_STATES = {
  EXCLUDE: "exclude", // Show as excluded in UI
  FOUNDATION_DISABLED: "foundation_disabled", // Foundation level disabled
  GLOBAL_DISABLED: "global_disabled" // Global level disabled
};

// Pendo tracking IDs for analytics
export const PENDO_IDS = {
  NOTIFICATION_PREFERENCES_PAGE: "notification-preferences-page"
};
